import { render, staticRenderFns } from "./R05.vue?vue&type=template&id=f9bc0182&scoped=true"
import script from "./R05.vue?vue&type=script&lang=js"
export * from "./R05.vue?vue&type=script&lang=js"
import style0 from "./R05.vue?vue&type=style&index=0&id=f9bc0182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bc0182",
  null
  
)

export default component.exports